export * from '@prisma/client';
export { prisma as database } from './client';
